"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMemoObject = void 0;
const react_1 = require("react");
const useMemoObject = (object) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return react_1.useMemo(() => object, Object.values(object));
};
exports.useMemoObject = useMemoObject;
//# sourceMappingURL=useMemoObject.js.map